import type { InMemoryCache, TypePolicies } from '@apollo/client';
import { useApolloClient } from '@apollo/client';

const mergeTypes = [
  'CompanyLogos',
  'HtmlDescription',
  'JobCompanyInfo',
  'JobHiringContact',
  'JobLocation',
  'JobUserInteractions',
  'JobXingApplication',
  'JobXingCustomApplication',
  'JobMatchingHighlightsV2',
];

const mergeTypePolicies = mergeTypes.reduce(
  (acc: TypePolicies, currentType) => {
    acc[currentType] = { merge: true };

    return acc;
  },
  {}
);

export const useVisibleJobTypePolicies = (): void => {
  // oxlint-disable-next-line typescript/consistent-type-assertions
  (useApolloClient().cache as InMemoryCache).policies.addTypePolicies(
    mergeTypePolicies
  );
};
